module.exports = __webpack_public_path__ + "img/01.76d33acb.jpg";